var modules_74c5b1b9 = {"container":"_zdmvtl","fullscreen":"_5mruuz","overlay":"_1097xyo","backdrop":"_oyen9h","header":"_fy1l25","content":"_184bpmt","title":"_1t5zyux","title-wrapper":"_m59im8","subtitle":"_17muzzf","close":"_dafifa","icon":"_1wfda2t","footer":"_yquaph","default-direction":"_hio5o8","default-justify":"_1rcd01q"};
import "../../../assets/DSISbFFb.css";

export { modules_74c5b1b9 as default };
//# sourceMappingURL=Dialog.module.less.js.map
